import { NgModule } from "@angular/core";
import { RepositoryFactoryProvider } from "../../../common/utils/backend.provider";
import { LocalStorageRepositoryInterface } from "../local-storage/local-storage.interface";
import { LoadingOverlayService } from "../../components/loading-overlay/services/loading-overlay.service";
import { RouterService } from "../../services/router.service";
import { TokenService } from "../../services/user/token.service";
import { UsersHttpBackend } from "../users/users.backend";
import { BusinessUnitsRepository } from "./business-units.repository";
import { BusinessUnitsRepositoryInterface } from "./business-units.interface";

@NgModule({
  providers: [
    RepositoryFactoryProvider({
      provide: BusinessUnitsRepositoryInterface,
      repository: BusinessUnitsRepository,
      backend: UsersHttpBackend,
      deps: [
        LocalStorageRepositoryInterface,
        RouterService,
        LoadingOverlayService,
        TokenService
      ]
    })
  ]
})
export class BusinessUnitsRepositoryModule { }